import stbAPIGateway from '../../../../services/stbAPIGateway';

export const fetchStudentManagementVendorList = async ({ rootGetters, commit }) => {
  const axios = rootGetters['app/stbAxios'];
  const apiUrl = process.env.API_URL || '';
  const stbApi = stbAPIGateway(axios, apiUrl);
  const response = await stbApi.getStudentManagementVendorList();
  if (response.data) {
    commit('setClientStudentManagementVendorsList', response.data);
  }
  return response;
};
